export default function SvgHorizontal() {
    return (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          cursor="pointer"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 13a1 1 0 100-2 1 1 0 000 2zM12 13a1 1 0 100-2 1 1 0 000 2zM5 13a1 1 0 100-2 1 1 0 000 2z"
          ></path>
        </svg>
      </>
    );
  }
  